import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X, ArrowUp } from 'react-bootstrap-icons';
import { deleteSubCategoryFromCategory } from '../../../../../../../../crud/menu_api/categories';
import { toast } from 'react-toastify';
import './PromoteSubcategoryModal.scss';

interface PromoteSubcategoryModalProps {
  show: boolean;
  onHide: () => void;
  subcategoryId: number;
  subcategoryName: string;
  parentCategoryName: string;
  onSuccess: () => void;
}

const PromoteSubcategoryModal: React.FC<PromoteSubcategoryModalProps> = ({
  show,
  onHide,
  subcategoryId,
  subcategoryName,
  parentCategoryName,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const handlePromote = async () => {
    setLoading(true);
    try {
      await deleteSubCategoryFromCategory(subcategoryId);
      toast.success(`"${subcategoryName}" ahora es una categoría principal`);
      onSuccess();
      onHide();
    } catch (error) {
      console.error('Error promoting subcategory:', error);
      toast.error('Error al promover la categoría');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      className="promote-subcategory-modal"
    >
      <Modal.Header>
        <div className="modal-header-content">
          <div className="modal-icon">
            <ArrowUp size={24} />
          </div>
          <Modal.Title>Promover a Categoría Principal</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="promote-modal-content">
          <div className="info-section">
            <p className="main-message">
              ¿Deseas promover <strong>"{subcategoryName}"</strong> a categoría principal?
            </p>
            
            <div className="change-details">
              <div className="detail-row current">
                <span className="label">Estado actual:</span>
                <span className="value">
                  Subcategoría de <strong>{parentCategoryName}</strong>
                </span>
              </div>
              
              <div className="arrow-separator">
                <ArrowUp size={20} />
              </div>
              
              <div className="detail-row new">
                <span className="label">Nuevo estado:</span>
                <span className="value">
                  Categoría principal independiente
                </span>
              </div>
            </div>

            <div className="warning-box">
              <div className="warning-icon">ℹ️</div>
              <div className="warning-text">
                <strong>Nota:</strong> Esta acción no elimina la categoría, solo la independiza. 
                Podrás volver a asignarla como subcategoría más tarde si lo deseas.
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button 
          variant="none" 
          className="btn-cancel" 
          onClick={onHide}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button 
          variant="none" 
          className="btn-promote" 
          onClick={handlePromote}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Promoviendo...
            </>
          ) : (
            <>
              <ArrowUp size={18} />
              Promover a Principal
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PromoteSubcategoryModal;
